export function ColorFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M11.088 2.042a6.844 6.844 0 012.687.254c1.197.346 1.848 1.354 2.118 2.328.27.975.222 2.092-.123 3.021-.295.796-.344 1.625.107 2.449.369.673.891 1.02 1.474 1.197.95.288 1.974.896 2.707 1.687.72.776 1.332 1.935.915 3.217-.22.675-.523 1.228-1.074 1.937a10 10 0 11-8.812-16.09zM9 9a1 1 0 100-2 1 1 0 000 2zm-1 6a2 2 0 100-4 2 2 0 000 4zm7 1a2 2 0 11-4 0 2 2 0 014 0z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
